export default "__VITE_ASSET__xMypsOiH__"